import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BlockQuoteCitation from './BlockQuoteCitation.js';
import BlockQuoteContent from './BlockQuoteContent.js';

/**
 * Main block quote element
 */

var StyledFigure = /*#__PURE__*/styled.figure.withConfig({
  componentId: "sc-1w1b0ss-0"
})(["margin:0;"]);
var StyledBlockQuote = /*#__PURE__*/styled.blockquote.withConfig({
  componentId: "sc-1w1b0ss-1"
})(["margin:0;"]);
var BlockQuote = function BlockQuote(_ref) {
  var children = _ref.children;
  var contentElement = React.Children.toArray(children).find(function (child) {
    return child.type === BlockQuoteContent;
  });
  var citationElement = React.Children.toArray(children).find(function (child) {
    return child.type === BlockQuoteCitation;
  });
  return /*#__PURE__*/React.createElement(StyledFigure, null, /*#__PURE__*/React.createElement(StyledBlockQuote, null, contentElement), citationElement && /*#__PURE__*/React.createElement("figcaption", null, citationElement));
};
BlockQuote.Content = BlockQuoteContent;
BlockQuote.Citation = BlockQuoteCitation;
BlockQuote.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Children of BlockQuote.Content and BlockQuote.Citation
   */
  children: PropTypes.node.isRequired
} : {};

/** @component */
var BlockQuote$1 = BlockQuote;

export { BlockQuote$1 as default };
